<template>
  <p>
    <b>Descargar datos:</b>
  </p>
  <List marked>
    <li>
      <a
        href="https://www.igp.gob.pe/resources/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/data/PP_prods/"
        target="_blank"
      >
        PP_prods
      </a>
    </li>
    <li>
      <a
        href="https://www.igp.gob.pe/resources/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/data/PX1000/"
        target="_blank"
      >
        PX1000
      </a>
    </li>
  </List>
</template>
<script>
export default {
  setup() {
    const basePath = process.env.VUE_APP_PUBLIC_PATH;
    return {
      basePath,
    };
  },
};
</script>
